import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import 'src/assets/charts/amchart/amcharts.js';
import 'src/assets/charts/amchart/serial.js';
import { LookupResult } from '../../types/lookup-result';
import { Entry } from '../../types/entry';
import { AuthStore } from '../../../core/auth/services/auth.store';
import { TranslatePipe } from '../../pipes/translate.pipe';


declare const AmCharts: any;

@Component({
  selector: 'app-kpi-chart',
  templateUrl: './kpi-chart.component.html',
  styleUrls: ['./kpi-chart.component.css'],
})
export class KpiChartComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {
  @Input() selector = 'chart';
  @Input() provider = [];
  @Input() type = 'serial';
  @Input() height = 300;
  @Input() options = {};
  prefix: number = new Date().getTime();
  @Input() hasLegend: boolean;
  private defaults = {
    fontFamily: '',

    hideCredits: true,
    marginRight: 0,
    valueAxes: [
      {
        axisAlpha: 0,
        dashLength: 6,
        gridAlpha: 0.1,
        position: 'left',
        autoGridCount: false,
        precision: 0,
      },
    ],
    graphs: [
      {
        id: 'g1',
        bullet: 'round',
        bulletSize: 9,
        lineColor: '#00897b',
        lineThickness: 2,
        title: this.translator.transform('Revenue'),
        negativeLineColor: '#00897b',
        valueField: 'value',
      },
      {
        id: 'g2',
        bullet: 'round',
        bulletSize: 9,
        lineColor: 'rgba(253,86,33,255)',
        title: this.translator.transform('Expenses'),
        lineThickness: 2,
        negativeLineColor: 'rgba(253,86,33,255)',
        valueField: 'value1',
      },
    ],

    categoryField: 'key',
    categoryAxis: {
      gridAlpha: 0,
      axisAlpha: 0,
      fillAlpha: 1,
      fillColor: '#FAFAFA',
      minorGridAlpha: 0,
      minorGridEnabled: true,
    },
    export: {
      enabled: true,
    },
  };
  private legend: {};
  private chart;
  constructor(private translator: TranslatePipe) {
    this.options = { ...this.defaults, ...this.options };
  }

  ngOnInit() {}

  ngAfterViewInit() {
    if (this.hasLegend) {
      this.legend = {
        legend: {
          useGraphSettings: false,
          position: 'right',
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0,
        },
      };
      this.options = { ...this.legend, ...this.options };
    }
    this.chart = AmCharts.makeChart(this.prefix + '_' + this.selector, {
      ...this.options,
      type: this.type,
      dataProvider: this.provider,
    });
  }

  private createChart() {
    if (this.chart) {
      this.chart.clear();
    }
    this.chart = AmCharts.makeChart(this.prefix + '_' + this.selector, {
      ...this.options,
      type: this.type,
      dataProvider: this.provider,
    });
  }
  ngOnDestroy() {
    if (this.chart) {
      // this.chart.destroy();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['provider'] &&
      Array.isArray(changes['provider'].currentValue) &&
      changes['provider'].currentValue.length > 0
    ) {
      this.createChart();
    }
  }
  
}
